import { Spin as BaseSpin } from "antd"

export function Spinner(props: React.ComponentProps<typeof BaseSpin>) {
    return <BaseSpin {...props} />
}
